import { Button, Grid, TextField, Typography } from "@mui/material";
import React, { useState } from "react";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function DeclinePayment({
  onClose,
  selectedRowId,
  showSnackbar,
}) {
  const userId = localStorage.getItem("userId");
  const [remark, setRemark] = useState(null);

  const handleCancel = () => {
    onClose();
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  // Cancel Payment
  const handleDeclinedPayment = async () => {
    // Handle form submission logic here
    if (remark === null) {
      showSnackbar("Please Add Remarks", "error");
      return;
    }
    const requestData = {
      user_id: parseInt(userId),
      miscellaneous_fee_id: selectedRowId,
      approval_status: "denied",
      denied_remarks: remark,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}miscellaneousfees/updateapprovalstatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // Make sure to keep the content type
          },
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        showSnackbar("Data Updated Successfully", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else if (response.status === 400) {
        showSnackbar("Please pass a valid approval status", "error");
      } else if (response.status === 401) {
        showSnackbar("Unauthorized User", "error");
      } else if (response.status === 405) {
        showSnackbar("Miscellaneous fee ID cannot be null", "error");
      } else if (response.status === 404) {
        showSnackbar("No active miscellaneous payment with this id", "error");
      } else if (response.status === 500) {
        showSnackbar("Server Error", "error");
      } else {
        showSnackbar("Server Error", "error");
      }
    } catch (error) {
      showSnackbar("Server Error", "error");
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography sx={{ fontWeight: 600 }}>
            Remark{" "}
            <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span>
          </Typography>
          <TextField
            placeholder="Type anything…"
            value={remark}
            fullWidth
            multiline
            rows={4}
            onChange={handleRemarkChange}
            InputProps={{ style: { borderRadius: "15px" } }}
          />
        </Grid>

        <Grid item xs={12} container gap={1} justifyContent="end">
          <Button onClick={handleCancel} variant="contained">
            Cancel
          </Button>
          <Button
            onClick={handleDeclinedPayment}
            autoFocus
            variant="contained"
            color="error"
          >
            Deny
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
